import { get_supportsRequestBodyjdtitrt33hir as get_supportsRequestBody } from '../../../../../../ktor-ktor-http/io/ktor/http/HttpMethod.mjs';
import {
  isEmpty1yq29t926r0va as isEmpty,
  ProtocolUpgradexnnpt2xliy8g as ProtocolUpgrade,
  NoContent1bdx48poqrifq as NoContent,
  ContentWrapper3n9gdymgnbto9 as ContentWrapper,
  WriteChannelContent1d7f40hsfcaxg as WriteChannelContent,
  ReadChannelContentz1amb4hnpqp4 as ReadChannelContent,
  ByteArrayContent2n0wb43y6ugs1 as ByteArrayContent,
} from '../../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { mergeHeadersub4y73mj759y as mergeHeaders } from '../Utils.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { toTypedArray3sl1vhn8ifta0 as toTypedArray } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnsupportedContentTypeException1omj39t4jp3a7 as UnsupportedContentTypeException } from '../../call/utils.mjs';
import { GlobalScope_instance1goye8260az8c as GlobalScope_instance } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  writer1eia5its2a1fh as writer,
  WriterScope3b0bo1enaee6b as WriterScope,
} from '../../../../../../ktor-ktor-io/io/ktor/utils/io/ByteWriteChannelOperations.mjs';
import { readRemaininghtnrfi4c8vp0 as readRemaining } from '../../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_toRaw__vjyxt3(_this__u8e3s4, clientConfig, callContext, $completion) {
  var jsHeaders = {};
  // Inline function 'io.ktor.client.request.forEachHeader' call
  var skipContentLengthHeader = !get_supportsRequestBody(_this__u8e3s4.y5k_1) && isEmpty(_this__u8e3s4.a5l_1);
  mergeHeaders(_this__u8e3s4.z5k_1, _this__u8e3s4.a5l_1, (key, value) => {
    var tmp;
    if (skipContentLengthHeader && key === 'Content-Length') {
      return Unit_instance;
    }
    jsHeaders[key] = value;
    return Unit_instance;
  });
  var tmp = getBodyBytes(_this__u8e3s4.a5l_1, callContext, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var bodyBytes = tmp;
  return buildObject(($this$buildObject) => {
    $this$buildObject.method = _this__u8e3s4.y5k_1.l50_1;
    $this$buildObject.headers = jsHeaders;
    var tmp;
    if (clientConfig.a5h_1) {
      // Inline function 'org.w3c.fetch.FOLLOW' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = 'follow';
    } else {
      // Inline function 'org.w3c.fetch.MANUAL' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = 'manual';
    }
    $this$buildObject.redirect = tmp;
    var tmp0_safe_receiver = bodyBytes;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$buildObject.body = new Uint8Array(toTypedArray(tmp0_safe_receiver));
    }
    return Unit_instance;
  });
}
function toRaw(_this__u8e3s4, clientConfig, callContext, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_toRaw__vjyxt3.bind(VOID, _this__u8e3s4, clientConfig, callContext), $completion);
}
function *_generator_getBodyBytes__kitznv(content, callContext, $completion) {
  var tmp;
  if (content instanceof ByteArrayContent()) {
    tmp = content.v55();
  } else {
    if (content instanceof ReadChannelContent()) {
      var tmp_0 = readRemaining(content.y55(), $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      tmp = readByteArray(tmp_0);
    } else {
      if (content instanceof WriteChannelContent()) {
        var tmp_1 = GlobalScope_instance;
        var tmp_2 = readRemaining(writer(tmp_1, callContext, VOID, getBodyBytes$slambda_0(content)).a4k_1, $completion);
        if (tmp_2 === get_COROUTINE_SUSPENDED())
          tmp_2 = yield tmp_2;
        tmp = readByteArray(tmp_2);
      } else {
        if (content instanceof ContentWrapper()) {
          var tmp_3 = getBodyBytes(content.e56(), callContext, $completion);
          if (tmp_3 === get_COROUTINE_SUSPENDED())
            tmp_3 = yield tmp_3;
          tmp = tmp_3;
        } else {
          if (content instanceof NoContent()) {
            tmp = null;
          } else {
            if (content instanceof ProtocolUpgrade()) {
              throw UnsupportedContentTypeException().m5k(content);
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
  }
  return tmp;
}
function getBodyBytes(content, callContext, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_getBodyBytes__kitznv.bind(VOID, content, callContext), $completion);
}
function buildObject(block) {
  var tmp = {};
  // Inline function 'kotlin.apply' call
  var this_0 = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  block(this_0);
  return this_0;
}
function *_generator_invoke__zhh2q8($this, $this$writer, $completion) {
  var tmp = $this.n5z_1.a56($this$writer.c4k_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var getBodyBytes$slambdaClass;
function getBodyBytes$slambda() {
  if (getBodyBytes$slambdaClass === VOID) {
    class $ {
      constructor($content) {
        this.n5z_1 = $content;
      }
      o58($this$writer, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$writer), $completion);
      }
      ud(p1, $completion) {
        return this.o58(p1 instanceof WriterScope() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    getBodyBytes$slambdaClass = $;
  }
  return getBodyBytes$slambdaClass;
}
function getBodyBytes$slambda_0($content) {
  var i = new (getBodyBytes$slambda())($content);
  var l = ($this$writer, $completion) => i.o58($this$writer, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  toRaw as toRawo597f5rz2rod,
};
//endregion

//# sourceMappingURL=JsUtils.mjs.map
